<!-- @format -->

@if (ready) {
  <div
    class="selection-box-slide"
    [ngClass]="{ 'selected-highlight': control.value === value }"
    (click)="selectSlide()"
    (keydown)="onSlideKeydown($event)">
    <div class="slide-input" [ngClass]="[fontSizeClass, minHeightClass]" #inputRef>
      <sis-radio-button
        [translatedLabel]="translatedTitle"
        [control]="control"
        [value]="value"
        [id]="id"
        [name]="name"
        [badgeText]="titleBadgeText"
        [badgeVariant]="titleBadgeVariant"
        [ariaDescribedBy]="ariaDescribedBy"
        data-cy="carousel-selection-radio-button">
      </sis-radio-button>
    </div>
    @for (banner of banners; track banner) {
      @if (banner) {
        <strong [id]="banner.id" class="banner" [ngClass]="banner.className">
          {{ banner.text }}
        </strong>
      }
    }
    <div class="slide-content">
      <ng-content></ng-content>
    </div>
  </div>
}
